import { useEffect, useState } from 'react';
import AgGridTable from '../../../components/table/AgGridTable';
import axiosInstance from '../../../axios/axios';
import { ColDef } from 'ag-grid-community';
import { Box, Chip, LinearProgress, Tooltip, Typography, Paper, Grid, Divider, useTheme } from '@mui/material';
import Exclamation from "../../../assets/Exclamation.png";
import AcceptedRisk_False from "../../../assets/baseVersion/AcceptedRisk_False.svg";

export const CyberResilienceRediretions = ({ event }: { event: any }) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [rowData, setRowData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    // Table for the event itself (currently unused but kept for future use)
    // const columnDefs = [
    //     {
    //         field: "event_code",
    //         headerName: "Event Code",
    //         filter: true,
    //         minWidth: 150,
    //         flex: 1,
    //         cellRenderer: (params: any) => (
    //             <Typography variant="body2" sx={{ fontWeight: 500 }}>
    //                 {params.value}
    //             </Typography>
    //         ),
    //     },
    //     {
    //         field: "reference_id",
    //         headerName: "Reference ID",
    //         filter: true,
    //         minWidth: 200,
    //         flex: 1,
    //         cellRenderer: (params: any) => (
    //             <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
    //                 {Number(params.value).toLocaleString('fullwide', { useGrouping: false })}
    //             </Typography>
    //         ),
    //     },
    //     {
    //         field: "event_name",
    //         headerName: "Event Type",
    //         filter: true,
    //         minWidth: 250,
    //         flex: 1,
    //         cellRenderer: (params: any) => (
    //             <Typography variant="body2" sx={{ fontWeight: 500 }}>
    //                 {params.value}
    //             </Typography>
    //         ),
    //     },
    //     {
    //         field: "current_score",
    //         headerName: "Security Score",
    //         filter: true,
    //         minWidth: 150,
    //         flex: 1,
    //         cellRenderer: (params: any) => (
    //             <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2' }}>
    //                 {params.value}
    //             </Typography>
    //         ),
    //     },
    //     {
    //         field: "score_difference",
    //         headerName: "Score Change",
    //         filter: true,
    //         minWidth: 150,
    //         flex: 1,
    //         cellRenderer: (params: any) => (
    //             <Typography
    //                 variant="body2"
    //                 sx={{
    //                     fontWeight: 600,
    //                     color: params.value >= 0 ? '#4caf50' : '#f44336'
    //                 }}
    //             >
    //                 {params.value >= 0 ? '+' : ''}{parseFloat(params.value).toFixed(2)}
    //             </Typography>
    //         ),
    //     },
    //     {
    //         field: "event_date",
    //         headerName: "Event Date",
    //         filter: true,
    //         minWidth: 200,
    //         flex: 1,
    //         cellRenderer: (params: any) => (
    //             <Typography variant="body2">
    //                 {new Date(params.value).toLocaleString()}
    //             </Typography>
    //         ),
    //     },
    // ];

    // Table for the fetched API data (customize columns as needed)
    const scanColumnDefs: ColDef[] = [
        {
            field: "controls",
            headerName: "Recommendation",
            filter: true,
            minWidth: 300,
            cellStyle: {
                display: "flex",
                // justifyContent: "center",
                alignItems: "center",
            },
            flex: 1,
            cellRenderer: (params: any) => {
                const value = params.value || "";
                // const shouldTruncate = value.length > 100;

                return (
                    <Tooltip title={value}>
                        <span style={{ width: "100%" }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "inline-block",
                                    width: "100%",
                                    fontWeight: "bold",
                                }}
                            >
                                {value}
                            </Typography>
                        </span>
                    </Tooltip>
                );
            },
        },

        {
            field: "severity",
            headerName: "Severity",
            filter: true,
            minWidth: 100,
            cellRenderer: (params: any) => {
                const severityStyles: any = {
                    Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
    High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
    Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
    Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
  };
                return (
                    <Chip
                        label={params.value}
                        size="small"
                        sx={{
                            bgcolor: severityStyles[params.value]?.bgcolor || "#f5f5f5",
                            color: severityStyles[params.value]?.color || "#666666",
                            height: "20px",
                            borderRadius: "4px",
                            position: "relative",
                            fontWeight: 600,
                            p: 1.5,
                            pr: 0,
                            "&::before": {
                                content: '""',
                                position: "absolute",
                                left: 8,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 8,
                                height: 8,
                                bgcolor: severityStyles[params.value]?.color || "#666666",
                                borderRadius: "50%",
                            },
                            "& .MuiChip-label": { px: 1 },
                        }}
                    />
                );
            },
            cellStyle: {
                display: "flex",
                alignItems: "center",
            },
        },
        {
            field: "accepted_count",
            headerName: "Risk Accepted",
            filter: true,
            minWidth: 150,
            cellRenderer: (params: any) =>
                params.value > 0 ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
                        <img src={Exclamation} alt="exclamation" height="20" />
                        <Typography>{params.value}</Typography>
                    </Box>
                ) : (<img
                    src={AcceptedRisk_False}
                    alt="warning"
                    style={{ height: "20px" }}
                />),
            cellStyle: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            },

        },
        {
            field: "compliance_count",
            headerName: "Compliance %",
            minWidth: 150,
            cellRenderer: (params: any) => (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={1}
                    width="100%"
                    mt={1}
                >
                    <Box width="100%">
                        <LinearProgress
                            variant="determinate"
                            value={params.value}
                            sx={{
                                height: 8,
                                borderRadius: 4,
                                backgroundColor: "#E0E0E0",
                                "& .MuiLinearProgress-bar": {
                                    backgroundColor: "#3CCB42",
                                },
                            }}
                        />
                    </Box>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ textAlign: "center" }}
                    >
                        {Math.floor(params.value).toFixed(2)}%
                    </Typography>
                </Box>
            ),
            cellStyle: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            },
        },
    ];

    // Only call API if event_code is 'new_scan' or 'rescan'
    useEffect(() => {
        if (
            event?.event_code === 'new_scan' ||
            event?.event_code === 'rescan'
        ) {
            if (!event?.referenceID) return;
            setLoading(true);
            axiosInstance
                .get(`securityscan/scan-summary-details?scan_summary_id=${event.referenceID}&module=on_premise`)
                .then(response => {
                    if (response.data?.data) {
                        const formattedData = response.data.data.map((control: any) => ({
                            id: control.id,
                            controls: control.param_name,
                            asset_count: control.asset_count,
                            compliance_passed_count: control.compliance_passed_count,
                            compliance_failed_count: control.compliance_failed_count,
                            accepted_count: control.accepted_count,
                            compliance_count: control.compliance_passed_percent,
                            tag_name: control.tag_name,
                            parameter_type: control.parameter_type,
                            severity: control.highest_priority,
                            control_type: control.control_type,
                            reference_id: control.referenceID,
                        }));
                        setRowData(formattedData);
                    }
                })
                .catch(() => {
                    setRowData([]);
                    // Optionally handle error
                })
                .finally(() => setLoading(false));
        } else if (event?.event_code === 'cloud') {
            if (!event?.referenceID) return;
            setLoading(true);
            axiosInstance
                .get(`securityscan/scan-summary-details?scan_summary_id=${event.referenceID}&module=cloud`)
                .then(response => {
                    if (response.data?.data) {
                        const formattedData = response.data.data.map((control: any) => ({
                            id: control.id,
                            controls: control.param_name,
                            asset_count: control.asset_count,
                            compliance_passed_count: control.compliance_passed_count,
                            compliance_failed_count: control.compliance_failed_count,
                            accepted_count: control.accepted_count,
                            compliance_count: control.compliance_passed_percent,
                            tag_name: control.tag_name,
                            parameter_type: control.parameter_type,
                            severity: control.highest_priority,
                            control_type: control.control_type,
                        }));
                        setRowData(formattedData);
                    }
                })
                .catch(() => {
                    setRowData([]);
                    // Optionally handle error
                })
                .finally(() => setLoading(false));
        } else {
            // For non-scan events (like accepted_risk), show basic event details
            if (event) {
                console.log(event, 'event')
                const basicEventData = [{
                    id: event.eventid || '',
                    event_code: event.event_code || '',
                    reference_id: event.referenceID || '',
                    event_name: event.event_type || event.event_name||'',
                    current_score: event.security_score || event.current_score|| '',
                    score_difference: event.score_change ||event.previous_score|| '',
                    event_date: event.time ? new Date().toISOString() : new Date().toISOString(), // Use current date if time is provided
                    event_time: event.time || '', // Store the time separately
                }];
                setRowData(basicEventData);
                console.log(basicEventData, 'basicEventData')
            } else {
                setRowData([]);
            }
        }
    }, [event]);

    const shouldShowApiTable =
        event?.event_code === 'new_scan' || event?.event_code === 'rescan' || event?.event_code === 'cloud';

    return (
        <div>
            {!shouldShowApiTable && (
                <Box sx={{ p: 2, height: '100%', overflowY: 'auto' }}>
                    {rowData.length > 0 ? (
                        <Paper elevation={0} sx={{
                            p: 2,
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            bgcolor: 'background.paper'
                        }}>
                            <Typography variant="h6" sx={{ mb: 2, fontWeight: 500, color: 'text.primary', fontSize: '1.1rem' }}>
                                Event Details
                            </Typography>

                            <Grid container spacing={2}>
                                {/* Event Code */}
                                <Grid item xs={12} sm={6}>
                                    {rowData[0].event_code && (
                                        <Box sx={{ mb: 1.5 }}>
                                            <Typography variant="body2" sx={{
                                                color: 'text.secondary',
                                                mb: 1,
                                                fontWeight: 500,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                fontSize: '0.7rem'
                                            }}>
                                                Event Code
                                            </Typography>
                                            <Box sx={{
                                                p: 1.5,
                                                borderRadius: 1.5,
                                                bgcolor: 'rgba(99, 102, 241, 0.08)',
                                                border: '1px solid rgba(99, 102, 241, 0.15)',
                                            }}>
                                                <Typography variant="body1" sx={{
                                                    fontWeight: 500,
                                                    color: '#6366f1',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    fontSize: '0.875rem'
                                                }}>
                                                    {rowData[0].event_code}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </Grid>

                                {/* Reference ID */}
                                <Grid item xs={12} sm={6}>
                                    {rowData[0].reference_id && (
                                        <Box sx={{ mb: 1.5 }}>
                                            <Typography variant="body2" sx={{
                                                color: 'text.secondary',
                                                mb: 1,
                                                fontWeight: 500,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                fontSize: '0.7rem'
                                            }}>
                                                Reference ID
                                            </Typography>
                                            <Box sx={{
                                                p: 1.5,
                                                borderRadius: 1.5,
                                                bgcolor: 'rgba(99, 102, 241, 0.08)',
                                                border: '1px solid rgba(99, 102, 241, 0.15)',
                                            }}>
                                                <Typography variant="body1" sx={{
                                                    fontWeight: 500,
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    fontSize: '0.875rem'
                                                }}>
                                                    {rowData[0].reference_id}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </Grid>

                                {/* Event Type */}
                                <Grid item xs={12}>
                                    {rowData[0].event_name && (
                                        <Box sx={{ mb: 1.5 }}>
                                            <Typography variant="body2" sx={{
                                                color: 'text.secondary',
                                                mb: 1,
                                                fontWeight: 500,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                fontSize: '0.7rem'
                                            }}>
                                                Event Type
                                            </Typography>
                                            <Box sx={{
                                                p: 1.5,
                                                borderRadius: 1.5,
                                                bgcolor: 'rgba(16, 185, 129, 0.08)',
                                                border: '1px solid rgba(16, 185, 129, 0.15)',
                                            }}>
                                                <Typography variant="body1" sx={{
                                                    fontWeight: 500,
                                                    color: '#10b981'
                                                }}>
                                                    {rowData[0].event_name}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </Grid>

                                <Divider sx={{ my: 1.5, width: '100%', opacity: 0.6 }} />

                                {/* Security Score */}
                                <Grid item xs={12} sm={6}>
                                    {rowData[0].current_score && (
                                        <Box sx={{ mb: 1.5 }}>
                                            <Typography variant="body2" sx={{
                                                color: 'text.secondary',
                                                mb: 1,
                                                fontWeight: 500,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                fontSize: '0.7rem'
                                            }}>
                                                Security Score
                                            </Typography>
                                            <Box sx={{
                                                p: 1.5,
                                                borderRadius: 1.5,
                                                bgcolor: 'rgba(59, 130, 246, 0.08)',
                                                border: '1px solid rgba(59, 130, 246, 0.15)',
                                                textAlign: 'center'
                                            }}>
                                                <Typography variant="h5" sx={{
                                                    fontWeight: 600,
                                                    color: '#3b82f6'
                                                }}>
                                                    {rowData[0].current_score}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </Grid>

                                {/* Score Change */}
                                <Grid item xs={12} sm={6}>
                                    {rowData[0].score_difference && (
                                        <Box sx={{ mb: 1.5 }}>
                                            <Typography variant="body2" sx={{
                                                color: 'text.secondary',
                                                mb: 1,
                                                fontWeight: 500,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                fontSize: '0.7rem'
                                            }}>
                                                Score Change
                                            </Typography>
                                            <Box sx={{
                                                p: 1.5,
                                                borderRadius: 1.5,
                                                bgcolor: rowData[0].score_difference >= 0 ? 'rgba(16, 185, 129, 0.08)' : 'rgba(239, 68, 68, 0.08)',
                                                border: `1px solid ${rowData[0].score_difference >= 0 ? 'rgba(16, 185, 129, 0.15)' : 'rgba(239, 68, 68, 0.15)'}`,
                                                textAlign: 'center'
                                            }}>
                                                <Typography variant="h5" sx={{
                                                    fontWeight: 600,
                                                    color: rowData[0].score_difference >= 0 ? '#10b981' : '#ef4444'
                                                }}>
                                                    {rowData[0].score_difference >= 0 ? '+' : ''}{parseFloat(rowData[0].score_difference).toFixed(2)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </Grid>

                                <Divider sx={{ my: 1.5, width: '100%', opacity: 0.6 }} />

                                {/* Event Date */}
                                <Grid item xs={12}>
                                    {rowData[0].event_date && (
                                        <Box sx={{ mb: 1.5 }}>
                                            <Typography variant="body2" sx={{
                                                color: 'text.secondary',
                                                mb: 1,
                                                fontWeight: 500,
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                fontSize: '0.7rem'
                                            }}>
                                                Event Date
                                            </Typography>
                                            <Box sx={{
                                                p: 1.5,
                                                borderRadius: 1.5,
                                                bgcolor: 'rgba(107, 114, 128, 0.05)',
                                                border: '1px solid rgba(107, 114, 128, 0.15)',
                                            }}>
                                                <Typography variant="body1" sx={{
                                                    fontWeight: 400,
                                                    color: '#6b7280'
                                                }}>
                                                    {rowData[0].event_time ?
                                                        `${new Date().toLocaleDateString('en-GB')} ${rowData[0].event_time}` :
                                                        new Date(rowData[0].event_date).toLocaleDateString('en-GB') + ' ' + new Date(rowData[0].event_date).toLocaleTimeString()
                                                    }
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                        </Paper>
                    ) : (
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%'
                        }}>
                            <Typography variant="body1" color="text.secondary">
                                No event data available
                            </Typography>
                        </Box>
                    )}
                </Box>
            )}
            {shouldShowApiTable && (
                <div style={{ marginTop: 24 }}>
                    <AgGridTable
                        columnDefs={scanColumnDefs}
                        data={rowData}
                        showSearch={true}
                        height='80vh'
                        isLoading={loading}
                    />
                </div>
            )}
        </div>
    );
}
